import { render, staticRenderFns } from "./SemenQuaratineThreePage.vue?vue&type=template&id=15075ef0&scoped=true&"
import script from "./SemenQuaratineThreePage.vue?vue&type=script&lang=js&"
export * from "./SemenQuaratineThreePage.vue?vue&type=script&lang=js&"
import style0 from "./SemenQuaratineThreePage.vue?vue&type=style&index=0&id=15075ef0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15075ef0",
  null
  
)

export default component.exports